// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__29BmA","actions":"GroupTable_actions__3b255","deleteModalFooter":"GroupTable_deleteModalFooter__35lKG"};